import routerOptions0 from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}